import { baseApi } from "./baseApi";

export const homepageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Public endpoints
    getCourseAds: builder.query({
      query: (params = {}) => ({
        url: "/homepage/course-ads",
        params,
      }),
      providesTags: ["CourseAd"],
    }),

    getCourseAdDetail: builder.query({
      query: (id) => `/homepage/course-ads/${id}`,
      providesTags: (result, error, id) => [{ type: "CourseAd", id }],
    }),

    getFeedbacks: builder.query({
      query: () => "/homepage/feedbacks",
      providesTags: ["Feedback"],
    }),

    // Student ranking (own class)
    getStudentRanking: builder.query({
      query: () => "/homepage/ranking",
      providesTags: ["Ranking"],
    }),

    // Admin ranking (all classes or filtered by classId)
    getAdminRanking: builder.query({
      query: (params = {}) => ({
        url: "/homepage/admin/ranking",
        params,
      }),
      providesTags: ["Ranking"],
    }),

    // Admin CRUD - Course Ads
    getAdminCourseAds: builder.query({
      query: (params = {}) => ({
        url: "/homepage/admin/course-ads",
        params,
      }),
      providesTags: ["CourseAd"],
    }),

    createCourseAd: builder.mutation({
      query: (data) => ({
        url: "/homepage/admin/course-ads",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CourseAd"],
    }),

    updateCourseAd: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/homepage/admin/course-ads/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["CourseAd"],
    }),

    deleteCourseAd: builder.mutation({
      query: (id) => ({
        url: `/homepage/admin/course-ads/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CourseAd"],
    }),

    // Admin CRUD - Feedbacks
    getAdminFeedbacks: builder.query({
      query: (params = {}) => ({
        url: "/homepage/admin/feedbacks",
        params,
      }),
      providesTags: ["Feedback"],
    }),

    createFeedback: builder.mutation({
      query: (data) => ({
        url: "/homepage/admin/feedbacks",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Feedback"],
    }),

    updateFeedback: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/homepage/admin/feedbacks/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Feedback"],
    }),

    deleteFeedback: builder.mutation({
      query: (id) => ({
        url: `/homepage/admin/feedbacks/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Feedback"],
    }),

    // Public - Hero Banners
    getPublicHeroBanners: builder.query({
      query: () => "/homepage/hero-banners",
      providesTags: ["HeroBanner"],
    }),

    // Admin CRUD - Hero Banners
    getAllHeroBanners: builder.query({
      query: (params = {}) => ({
        url: "/homepage/admin/hero-banners",
        params,
      }),
      providesTags: ["HeroBanner"],
    }),

    createHeroBanner: builder.mutation({
      query: (data) => ({
        url: "/homepage/admin/hero-banners",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["HeroBanner"],
    }),

    updateHeroBanner: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/homepage/admin/hero-banners/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["HeroBanner"],
    }),

    deleteHeroBanner: builder.mutation({
      query: (id) => ({
        url: `/homepage/admin/hero-banners/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["HeroBanner"],
    }),
  }),
});

export const {
  useGetCourseAdsQuery,
  useGetCourseAdDetailQuery,
  useGetFeedbacksQuery,
  useGetStudentRankingQuery,
  useGetAdminRankingQuery,
  useLazyGetAdminRankingQuery,
  useGetAdminCourseAdsQuery,
  useCreateCourseAdMutation,
  useUpdateCourseAdMutation,
  useDeleteCourseAdMutation,
  useGetAdminFeedbacksQuery,
  useCreateFeedbackMutation,
  useUpdateFeedbackMutation,
  useDeleteFeedbackMutation,
  useGetPublicHeroBannersQuery,
  useGetAllHeroBannersQuery,
  useCreateHeroBannerMutation,
  useUpdateHeroBannerMutation,
  useDeleteHeroBannerMutation,
} = homepageApi;
